export default function getResource(label) {
    const resources = {
        freeReturns: 'Retours gratuits',
        exclusions: 'voir les détails et les exceptions*.'
    };

    return resources[label];
}
